"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLightbulb(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M11.914 0a7.916 7.916 0 017.916 7.917c0 2.69-1.351 4.985-3.72 6.708l.015-.017c-.09.081-.182.258-.253.504-.079.276-.116.565-.126.776l-.004.114.002 1.347v.07l-.001 3.652-.01.122c-.063.388-.256.911-.669 1.434-.635.805-1.597 1.307-2.888 1.367l-.262.006c-1.422 0-2.472-.514-3.15-1.373a3.3 3.3 0 01-.643-1.3l-.026-.134-.01-.122v-5.068l.002-.028-.002-.028c0-.205-.036-.549-.139-.873a1.368 1.368 0 00-.2-.415l-.036-.042-.19-.14C5.276 12.772 4 10.53 4 7.917A7.915 7.915 0 0111.914 0zM9.617 18.511v2.485l.006.026c.035.135.115.329.253.533l.09.123c.36.455.905.743 1.735.785l.213.005c.952 0 1.56-.297 1.948-.79a1.88 1.88 0 00.343-.656l.006-.03v-2.44c-1.532.515-3.105.431-4.594-.04zm2.297-16.98a6.383 6.383 0 00-6.382 6.386c0 2.178 1.11 4.047 3.136 5.504a.77.77 0 01.101.087l-.017-.017c.305.293.514.675.655 1.12.16.504.21.988.21 1.336l-.002.027.002.03v.883c.11.044.24.09.384.138 1.385.456 2.84.497 4.21-.118v-.905c0-.34.047-.818.19-1.313.137-.481.347-.886.664-1.188l.015-.013a.328.328 0 01.011-.01l.04-.035a.779.779 0 01.03-.022c2.027-1.457 3.137-3.327 3.137-5.504a6.384 6.384 0 00-6.384-6.385z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgLightbulb;
exports.default = _default;